/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { moneyFixed } from '@/tools/money';

import { payStatusRender } from '@/page/settlementCenter/utils';

// 结算总价列表 带入了相关接口与参数： 部分/已支付/失效
export { projectPriceHanderl } from '@/page/settlementCenter/common/tableConfig/fields';

export default {
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },

  fullName: {
    label: '项目参与人姓名',
    prop: 'fullName'
  },
  phone: {
    label: '手机号',
    prop: 'phone'
  },

  userPhone: {
    label: '手机号',
    prop: 'userPhone'
  },
  orderNo: {
    label: '订单编号',
    prop: 'orderNo'
  },
  projectName: {
    label: '项目名称',
    prop: 'projectName'
  },
  taskDt: {
    label: '任务月度',
    prop: 'taskDt'
  },
  supplier: {
    label: '供应商',
    prop: 'supplierName'
  },
  partA: {
    label: '合同甲方',
    prop: 'partA'
  },
  partB: {
    label: '合同乙方',
    prop: 'partB'
  },
  feeType: {
    label: '费用类别',
    prop: 'feeType'
  },
  signType: {
    label: '合同类别',
    prop: 'signType'
  },
  signDt: {
    label: '签约时间',
    prop: 'signDt'
  },
  amount: {
    label: '金额',
    prop: 'amount'
  },
  finishDt: {
    label: '结算月度',
    prop: 'finishDt'
  },
  certificationServiceFee: {
    label: '综合服务费',
    prop: 'certificationServiceFee',
    render: function(h, ctx, r, c) {
      const val = moneyFixed([r[c.property]]);
      const { type } = ctx.parent.$parent;
      if ([2, 3, 4].includes(type) && r.supplierId) {
        return h('span', '-');
      }
      return h('span', val);
    }
  },
  finishPayPrice: {
    label: '累计结算金额',
    prop: 'sumProjectPrice',
    render(h, ctx, row, c) {
      const vm = ctx.parent;
      const handler = () => {
        vm.$xrkDialog({
          title: '累计结算金额',
          showConfirm: false,
          cancelText: '关闭',
          $slots: {
            default: h(require('../child/leijijiesuan.vue').default, {
              props: {
                activeId: row.id + ''
              }
            })
          }
        });
      };
      return (
        <div class="orderPrice">
          <el-button type="text" onClick={handler}>
            {moneyFixed([row[c.property]])}
          </el-button>
        </div>
      );
    }
  },
  orderPrice: {
    label: '累计结算金额',
    prop: 'orderPrice',
    render: function(h, ctx, r, c) {
      const val = moneyFixed([r[c.property]]);
      const { type } = ctx.parent.$parent;
      if ([2, 3, 4].includes(type) && r.supplierId) {
        return h('span', '-');
      }
      return h('span', val);
    }
  },
  finishSumTaskPrice: {
    label: '累计已收取服务费',
    prop: 'csoSumPayServicePrice',
    // render: function(h, ctx, r, c) {
    //   const val = moneyFixed([r[c.property]]);
    //   const { type } = ctx.parent.$parent;
    //   if ([2, 3, 4].includes(type) && r.supplierId) {
    //     return h('span', '-');
    //   }
    //   return h('span', val);
    // }
    render(h, ctx, row, c) {
      const vm = ctx.parent;
      const handler = () => {
        vm.$xrkDialog({
          title: '累计已收取服务费',
          showConfirm: false,
          cancelText: '关闭',
          $slots: {
            default: h(require('../child/leijiyishouqu.vue').default, {
              props: {
                // ...projectPriceHanderlMap[type],
                // sourceType: type,
                activeId: row.id + ''
                // taskDt: row.taskDt,
                // csoCustomOrderSupplierId: row.id + ''
              }
            })
          }
        });
      };
      return (
        <div class="orderPrice">
          <el-button type="text" onClick={handler}>
            {moneyFixed([row[c.property]])}
          </el-button>
        </div>
      );
    }
  },
  csoServiceScale: {
    label: '实际服务费率',
    prop: 'csoServiceScale',
    formatter(r, c, v) {
      return (v / 100).toFixed(2) + '%';
    }
  },
  commission: {
    label: '平台服务费率',
    prop: 'commission',
    formatter(r, c, v) {
      return (v / 100).toFixed(2) + '%';
    }
  },
  totalPrice: {
    label: '应收服务费',
    prop: 'csoThisPayServicePrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  totalPrice1: {
    label: '综合服务费',
    prop: 'zongheMin',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  payStatus: {
    label: '支付状态',
    prop: 'payStatus',
    render: (h, ctx, r) => {
      return (
        <div>
          <span>{payStatusRender(r, null)}</span>
        </div>
      );
    }
  }
};
